// The 9 canonical Zoe dimensions.

export const DIMENSIONS = [
  'financial_vitality',
  'delivery_execution',
  'culture_people',
  'c_suite',
  'vision_strategy',
  'market_competition',
  'gtm',
  'product_customer',
  'risk',
] as const;

export type Dimension = (typeof DIMENSIONS)[number];

export interface DimensionMeta {
  id: Dimension;
  label: string;
  short: string;
  description: string;
}

export const DIMENSION_META: Record<Dimension, DimensionMeta> = {
  financial_vitality: {
    id: 'financial_vitality',
    label: 'Financial Vitality',
    short: 'Finance',
    description: 'Revenue quality, margin and unit economics, cash and runway',
  },
  delivery_execution: {
    id: 'delivery_execution',
    label: 'Delivery & Execution',
    short: 'Delivery',
    description: 'Shipping cadence, deploy velocity, sprint completion, deferred work',
  },
  culture_people: {
    id: 'culture_people',
    label: 'Culture & People',
    short: 'Culture',
    description: 'Retention, leadership alignment, team density, engagement',
  },
  c_suite: {
    id: 'c_suite',
    label: 'C-Suite',
    short: 'C-Suite',
    description: 'Defensibility, founder-market fit, decision quality',
  },
  vision_strategy: {
    id: 'vision_strategy',
    label: 'Vision & Strategy',
    short: 'Vision',
    description: 'Stack health, technical debt, roadmap coherence',
  },
  market_competition: {
    id: 'market_competition',
    label: 'Market & Competition',
    short: 'Market',
    description: 'Category standing, sector dynamics, positioning',
  },
  gtm: {
    id: 'gtm',
    label: 'GTM',
    short: 'GTM',
    description: 'Growth rate, pipeline coverage, funnel efficiency, ICP clarity',
  },
  product_customer: {
    id: 'product_customer',
    label: 'Product & Customer',
    short: 'Product',
    description: 'Net retention, satisfaction, escalations, customer concentration',
  },
  risk: {
    id: 'risk',
    label: 'Risk',
    short: 'Risk',
    description: 'Cap table, controls, compliance, dependency risk',
  },
};
